import { FETCHED, LOADING } from './constants';

const initialState = {
  isLoading: false,
  message: '',
  code: 0,
  username: '',
  key: '',
};

export default function reducer(state = initialState, action) {
  const { type, isLoading, message, code, username, key } = action;

  switch (type) {
    case FETCHED:
      return {
        ...state,
        message,
        code,
        username,
        key,
      };

    case LOADING:
      return {
        ...state,
        isLoading,
      };
    default:
      return state;
  }
}
